<ng-container *transloco="let t; read: 'upload'">
  <div class="w-full p-5">

    <drdp-title [title]="t('review.usersTitle')"></drdp-title>

    <drdp-container [additionClasses]="'min-h-[44rem]'">
      <div class="w-full ">
        <mat-card [ngClass]="cardColor">
          <mat-card-content>
            <div class="flex justify-between">
              <!-- Header-validation text is supplied by the shared upload helper. -->
              <p class="pt-2" [innerHTML]="cardText"></p>
              @if (!isFormValidated && !isFormValid && isHeaderValid) {
                <drdp-btn (click)="checkFile()">{{ t('review.checkFile') }}</drdp-btn>
              }
              @if (isFormValidated && isFormValid) {
                <drdp-btn (click)="save()">{{ t('review.submit') }}</drdp-btn>
              }
            </div>
          </mat-card-content>
        </mat-card>
        <div class="w-full">
          <drdp-btn class="float-right pt-10" (click)="uploadNewFile()" color="cancel"><i
          class="uil uil-plus text-lg"></i>{{ t('review.uploadNewFile') }}</drdp-btn>
        </div>
        <drdp-upload-table (onDataChange)="onDataChange($event)" [dataSource]="dataSource" [columns]="headerData">
        </drdp-upload-table>
      </div>
    </drdp-container>
    <div class="uploads-pagination">
      <mat-paginator [pageSizeOptions]="pageSizeOptions">
      </mat-paginator>
    </div>
  </div>
</ng-container>